import { REGIONS } from "@/lib/constants";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetRegions = () => {
  return useSuspenseQuery({
    queryKey: ["regions"],
    queryFn: async () => {
      try {
        return REGIONS;
      } catch (error) {
        console.error("Failed to fetch regions:", error);
        return [];
      }
    },
  });
};
